import React from "react";

export default () => (
    <svg x="0px" y="0px" viewBox="0 0 298.103 298.103">
        <g>
            <path
                d="M145.237,221.156c-13.923-14.47-21.416-32.87-22.461-51.578c-0.093-1.665-0.139-3.332-0.13-5H35.997
		c-3.312,0-5.997-2.685-5.997-5.997V74.575c0-3.312,2.685-5.997,5.997-5.997h163.146c3.312,0,5.997,2.685,5.997,5.997v9.484
		c10.469,0.195,20.611,2.353,30,6.322V70.577c0-17.673-14.327-32-32-32H32c-17.673,0-32,14.327-32,32v92c0,17.673,14.327,32,32,32
		h57.903v20.666H84.66c-8.077,0-15.027,6.207-15.407,14.275c-0.406,8.614,6.458,15.725,14.983,15.725h66.668
		c6.205,0,11.529-3.768,13.812-9.141c-6.67-3.661-12.866-8.277-18.396-13.807C145.948,221.923,145.601,221.534,145.237,221.156z"
            />
            <path
                d="M292.245,225.383c-16.281-16.281-19.361-19.362-35.258-35.258c10.257-21.87,6.371-48.783-11.67-66.824
		c-23.005-23.005-60.436-23.003-83.438,0c-23.003,23.004-23.003,60.435,0,83.439c17.954,17.954,44.827,21.987,66.824,11.67
		c23.282,23.282,12.135,12.135,35.258,35.258c7.809,7.809,20.474,7.811,28.285,0C300.056,245.858,300.056,233.194,292.245,225.383z
		M224.104,185.527c-11.334,11.334-29.678,11.335-41.013,0c-11.307-11.308-11.307-29.705,0-41.013
		c11.305-11.305,29.706-11.307,41.013,0C235.437,155.848,235.439,174.192,224.104,185.527z"
            />
        </g>
    </svg>
);
